import { useSelector } from "react-redux"
import { IRoles } from "../../../../../../utils"
import InProgressBusiness from "./InProgressBusiness"
import InProgressEmployee from "./employee/InProgressEmployee"

export function JobInProgress({ data, focusJobChat = false }) {
  const { role } = useSelector((state) => state.userState)
  const isEmployee = role?.type === IRoles.Employee

  return (
    isEmployee
      ? <InProgressEmployee data={data} focusJobChat={focusJobChat} />
      : <InProgressBusiness data={data} focusJobChat={focusJobChat} />
  )
}
